import {Component, OnInit} from "@angular/core";
import {FormGroup, FormControl, Validators} from "@angular/forms";
import {UserService} from "../../../shared/services/api_v1/user.service";

@Component({
    // moduleId: module.id,
    selector:'home-signup-form',
    templateUrl: './home-signup-form.component.html'
})
export class HomeSignupFormComponent implements OnInit{
    form: FormGroup;

    signup_failed = false;
    submitted = false;
    button_disabled = false;

    constructor(private userService:UserService){}

    ngOnInit() {
        this.form = new FormGroup({
            email: new FormControl('',[ Validators.required ]),
            fullname: new FormControl('',[ Validators.required ]),
            password: new FormControl('',[ Validators.required ]),
            password_again: new FormControl('',[ Validators.required ])
        });
    }

    signup(): void {
        if(this.form.invalid){ return; }
        this.submitted = false;
        this.button_disabled = true;

        this.userService.signup(
            this.form.get('fullname').value,
            this.form.get('email').value,
            this.form.get('password').value
        )
            .then(is_success => {
                this.submitted = true;
                this.signup_failed = false;
                this.button_disabled = false;
            })
            .catch(error => {
                this.submitted = true;
                this.signup_failed = true;
                this.button_disabled = false;
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/front/home/signup/home-signup-form.component.ts